var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M22.45 10.313h-2.2v-2.25a.558.558 0 00-.55-.563h-1.1a.558.558 0 00-.55.563v2.25h-2.2a.557.557 0 00-.55.562V12c0 .31.247.563.55.563h2.2v2.25c0 .309.247.562.55.562h1.1c.303 0 .55-.253.55-.563v-2.25h2.2c.303 0 .55-.253.55-.562v-1.125a.558.558 0 00-.55-.563zM8.7 12c2.43 0 4.4-2.014 4.4-4.5S11.13 3 8.7 3C6.27 3 4.3 5.014 4.3 7.5S6.27 12 8.7 12zm3.08 1.125h-.574a5.872 5.872 0 01-2.506.563c-.894 0-1.74-.204-2.506-.563H5.62C3.07 13.125 1 15.241 1 17.85v1.462C1 20.244 1.74 21 2.65 21h12.1c.91 0 1.65-.756 1.65-1.688V17.85c0-2.609-2.07-4.725-4.62-4.725z"
  }))));
}

export default SvgUserPlus;